import { watch } from 'vue'

import { useAuthStore } from '@/auth/useAuthStore'

import { useBrazeStore } from './useBrazeStore'

export const useBrazeLifecycle = (): void => {
  const authStore = useAuthStore()
  const brazeStore = useBrazeStore()

  watch(
    () => authStore.user?.id,
    (userId) => {
      if (userId) {
        void brazeStore.initializeBraze()
      } else {
        brazeStore.shutdownBraze()
      }
    },
    { immediate: true }
  )
}
